import React from "react";
import { Card } from "react-bootstrap";
import "../css/listOfSlides.scss";

const ListOfSubSlides = ({ slideData, parentSlideId, selectedCardHandler }) => {
  return (
    <div className="c-slides">
      {slideData.length !== 0 &&
        slideData?.map((el, i) => {
          const imageKey = Date.now();//Math.floor(Math.random() * 11);
          return (
            <span className="i-child-slide">
              <p className="slide-index">{parentSlideId + "." + el.index}</p>
              <Card className="p-slide">
                <img
                  className={"inactive"}
                  src={
                    el?.slideid?.thumbnailNew !== "https://cdn.link/image.png"
                      ? `${el?.slideid?.thumbnailNew}?n=${imageKey}`
                      : "https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
                  }
                  key={imageKey}
                  alt=""
                  // onLoad={(e) => imageLoaded(el.slideid._id, el?.slideid?.thumbnail)}
                />
              </Card>
            </span>
            // <span key={i}>
            //   <p>{parentSlideId + "." + el.index}</p>
            //   <div
            //     className={
            //       slideData.length !== 0 ? "childSlide-container" : "hide-slide"
            //     }
            //     style={{
            //       paddingBottom: el.index === slideData.length ? "17px" : "0px",
            //     }}
            //   >
            //     <div className="s-child">
            //       <Card className="c-slide" onClick={() => selectedCardHandler(parentSlideId, el?.slideid?._id)}>
            //         <img
            //           src={
            //             el?.slideid?.thumbnail !== "https://cdn.link/image.png"
            //               ? `${el?.slideid?.thumbnail}?n=${imageKey}`
            //               : "https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
            //           }
            //           key={imageKey}
            //           alt=""
            //         />
            //       </Card>
            //     </div>
            //   </div>
            // </span>
          );
        })}
    </div>
  );
};

export default ListOfSubSlides;
